import type { PositionedItem } from '../components/PageConfigProvider/types/item';
import type { MetricValues } from '../components/PageConfigProvider/types/metric';
import {
  companySentimentAdjustedMin,
  companySentimentDefaultMetric,
  companySentimentMaxValue,
} from '../templates/company-sentiment';
import {
  geographySentimentAdjustedMin,
  geographySentimentDefaultMetric,
  geographySentimentMaxValue,
} from '../templates/geography-sentiment';
import {
  roleSentimentAdjustedMin,
  roleSentimentDefaultMetric,
  roleSentimentMaxValue,
} from '../templates/role-sentiment';

export const getRevelioPageOverrides = (item: PositionedItem) => {
  const id = item?.id;

  const colorOverride = getColorOverride(id);
  const defaultMetric = getDefaultMetricOverrides(item);
  const sortByValue = getSortByValue(id);
  const maxValue = getMaxValue(id);
  const adjustedMin = getAdjustedMin(id);

  return {
    colorOverride,
    defaultMetric,
    sortByValue,
    maxValue,
    adjustedMin,
  };
};

const getAdjustedMin = (id: string) => {
  const adjustedMinOverrides: Record<string, number> = {
    ...companySentimentAdjustedMin,
    ...geographySentimentAdjustedMin,
    ...roleSentimentAdjustedMin,
  };

  return adjustedMinOverrides[id];
};

const getMaxValue = (id: string) => {
  const maxValueOverrides: Record<string, number> = {
    ...companySentimentMaxValue,
    ...geographySentimentMaxValue,
    ...roleSentimentMaxValue,
  };

  return maxValueOverrides[id];
};

const getSortByValue = (id: string) => {
  if (id === 'company-overview-competitors-headcount') {
    return true;
  }

  return false;
};

const getColorOverride = (id: string) => {
  if (id === 'company-overview-salary-distribution') {
    return '#70CA97';
  }

  return undefined;
};

// A prescribed set of metric values we care to detect in a chart item id.
const defaultMetricOverrides: Record<string, MetricValues> = {
  'company-overview-competitors-headcount': 'headcount',
  ...companySentimentDefaultMetric,
  ...geographySentimentDefaultMetric,
  ...roleSentimentDefaultMetric,
};

export const getDefaultMetricOverrides = (
  item: PositionedItem
): MetricValues | undefined => {
  const itemId = item?.id;

  if (!itemId) return undefined;

  if (defaultMetricOverrides[itemId]) {
    return defaultMetricOverrides[itemId];
  }

  const options = item?.plot?.defaultMetricOptions;
  if (!options || options.length === 0) return undefined;
  return options[0];
};
